import type { ColumnDef } from '@tanstack/react-table';

import { ColumnHeader } from '../column-header';
import type { SortingProps } from '../toolbar';
import { CellBadge } from '../typography';

export function statusBadgeColDef<T>(
  sorting: SortingProps,
  sortingAlign: 'start' | 'center' | 'end' = 'end',
  enableSorting: boolean = true
): ColumnDef<T>[] {
  const columns: ColumnDef<T>[] = [
    {
      accessorKey: 'status',
      meta: { name: 'Status', className: 'w-28' },
      header: ({ column }) => (
        <ColumnHeader sorting={sorting} column={column} sortingAlign={sortingAlign} align="center" />
      ),
      cell: ({ row }) => {
        const OStatus = row.getValue('status') as
          | ('inactive' | 'active' | null)
          | { name: string; value: 'inactive' | 'active' | null };

        const status = typeof OStatus === 'object' ? OStatus?.value : OStatus;
        return <CellBadge text={status ?? null} />;
      },
      enableSorting,
    },
  ];

  return columns;
}
